import { request } from "../../utils/config"

export const GET_HEADER_STATISTICS = async () => {
  const response = await request({
    url: `Reports/HeaderProductCounterpartyCount`,
    Headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
